import { render, staticRenderFns } from "./SalesDetailDialog.vue?vue&type=template&id=af9469e8&scoped=true&"
import script from "./SalesDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SalesDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9469e8",
  null
  
)

export default component.exports